import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2835dc25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "stills" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Blender Design", -1))

import { ref, shallowReactive, require } from "vue";
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
  Img,
  Book,
} from "vue-flux";
import "vue-flux/style.css";


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "StillImages",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $vueFlux = ref();

const vfOptions = shallowReactive({
  autoplay: true,
});

const vfRscs = shallowReactive([
  new Img(require("../images/23_1.png")),
  new Img(require("../images/39_1.png")),
  new Img(require("../images/64_1.png")),
  new Img(require("../images/bg.png")),
  new Img(require("../images/catch.png")),
  new Img(require("../images/CITY.png")),
  new Img(require("../images/dropFinal.png")),
  new Img(require("../images/entry_00000.png")),
  new Img(require("../images/geoWalker.png")),
  new Img(require("../images/house2 copy.png")),
  new Img(require("../images/kayboard.png")),
  new Img(require("../images/not.png")),
  new Img(require("../images/REACH.png")),
  new Img(require("../images/skull2.png")),
  new Img(require("../images/tubes.png")),
]);

const vfTransitions = shallowReactive([Book]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_unref(VueFlux), {
      options: _unref(vfOptions),
      rscs: _unref(vfRscs),
      transitions: _unref(vfTransitions),
      style: {"width":"80vw","margin-left":"10vw","margin-top":"5vw","height":"80vw"},
      ref_key: "$vueFlux",
      ref: $vueFlux
    }, {
      preloader: _withCtx((preloaderProps) => [
        _createVNode(_unref(FluxPreloader), _normalizeProps(_guardReactiveProps(preloaderProps)), null, 16)
      ]),
      caption: _withCtx((captionProps) => [
        _createVNode(_unref(FluxCaption), _normalizeProps(_guardReactiveProps(captionProps)), null, 16)
      ]),
      controls: _withCtx((controlsProps) => [
        _createVNode(_unref(FluxControls), _normalizeProps(_guardReactiveProps(controlsProps)), null, 16)
      ]),
      pagination: _withCtx((paginationProps) => [
        _createVNode(_unref(FluxPagination), _normalizeProps(_guardReactiveProps(paginationProps)), null, 16)
      ]),
      index: _withCtx((indexProps) => [
        _createVNode(_unref(FluxIndex), _normalizeProps(_guardReactiveProps(indexProps)), null, 16)
      ]),
      _: 1
    }, 8, ["options", "rscs", "transitions"])
  ]))
}
}

})